/* ROCKBROS NL BF v16 | real Amsterdam start countdown + physically correct half-card flip */
(() => {
  if (window.__rbnlBFRealFlipV16) return;
  window.__rbnlBFRealFlipV16 = true;

  const timePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/;
  const units = ['days', 'hours', 'minutes', 'seconds'];
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function glyph(el, sliceClass) {
    return el.querySelector(sliceClass + ' .sbf-flip__glyph');
  }

  function setDigit(el, number) {
    const next = String(number).padStart(2, '0');
    const old = el.dataset.value;
    if (old === next) return;
    const newTop = glyph(el, '.sbf-flip__slice--top-static');
    const oldBottom = glyph(el, '.sbf-flip__slice--bottom-static');
    const folding = glyph(el, '.sbf-flip__slice--top-fold');
    const unfolding = glyph(el, '.sbf-flip__slice--bottom-unfold');
    if (!newTop || !oldBottom || !folding || !unfolding) return;

    if (el.__sbfFlipComplete) clearTimeout(el.__sbfFlipComplete);
    el.__sbfFlipComplete = null;
    el.classList.remove('sbf-flip--turn');

    newTop.textContent = next;
    el.dataset.value = next;

    if (!old || reduceMotion || document.hidden) {
      oldBottom.textContent = next;
      folding.textContent = next;
      unfolding.textContent = next;
      return;
    }

    // The incoming number is visible on the top static half;
    // the outgoing number remains on the bottom until the new lower half unfolds.
    oldBottom.textContent = old;
    folding.textContent = old;
    unfolding.textContent = next;

    // One composite-friendly 3D movement of two actual half-height pieces.
    void el.offsetWidth;
    el.classList.add('sbf-flip--turn');
    el.__sbfFlipComplete = setTimeout(() => {
      oldBottom.textContent = next;
      el.classList.remove('sbf-flip--turn');
      el.__sbfFlipComplete = null;
    }, 660);
  }

  function init(root = document) {
    root.querySelectorAll('[data-sbf-start]').forEach(clock => {
      if (clock.__sbfTick) clearTimeout(clock.__sbfTick);
      const raw = clock.dataset.start || '';
      const target = Date.parse(raw);
      const card = clock.closest('.sbf-timer');
      if (!timePattern.test(raw) || !Number.isFinite(target)) {
        if (card) card.textContent = 'Startdatum wordt nog bevestigd.';
        return;
      }
      const title = card?.querySelector('[data-sbf-timer-title]');
      const status = card?.querySelector('[data-sbf-timer-status]');
      const caption = card?.querySelector('[data-sbf-timer-caption]');
      const digitElements = Object.fromEntries(units.map(name => [name,clock.querySelector('.sbf-flip[data-part="' + name + '"]')]));

      const render = () => {
        const remaining = Math.max(0,Math.ceil((target - Date.now())/1000));
        if (!remaining) {
          clock.hidden = true;
          if (title) title.textContent = clock.dataset.started || 'Black Friday is begonnen!';
          if (status) status.textContent = 'GESTART';
          if (caption) caption.textContent = 'De geplande starttijd is bereikt.';
          if (clock.__sbfTick) clearTimeout(clock.__sbfTick);
          clock.__sbfTick = null;
          return false;
        }
        clock.hidden = false;
        const time = {
          days: Math.floor(remaining / 86400),
          hours: Math.floor(remaining / 3600) % 24,
          minutes: Math.floor(remaining / 60) % 60,
          seconds: remaining % 60
        };
        for(const unit of units) if(digitElements[unit]) setDigit(digitElements[unit],time[unit]);
        clock.setAttribute('aria-label', 'Black Friday begint over: '+time.days+' dagen '+time.hours+' uur '+time.minutes+' minuten');
        return true;
      };

      function schedule() {
        if (!render()) return;
        const nextBoundary = 1000 - (Date.now() % 1000) + 15;
        clock.__sbfTick = setTimeout(schedule, nextBoundary);
      }
      schedule();
      clock.__sbfRefresh = () => {
        if(clock.__sbfTick) clearTimeout(clock.__sbfTick);
        schedule();
      };
    });
  }

  const onVisibility = () => {
    if(!document.hidden) document.querySelectorAll('[data-sbf-start]').forEach(clock => clock.__sbfRefresh?.());
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  document.addEventListener('visibilitychange', onVisibility);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-sbf-start]').forEach(clock => {
      if(clock.__sbfTick) clearTimeout(clock.__sbfTick);
      clock.querySelectorAll('.sbf-flip').forEach(el => {
        if(el.__sbfFlipComplete) clearTimeout(el.__sbfFlipComplete);
      });
    });
  });
})();